window.onerror = function (message, url, lineNo, colNo, error) {

    console.log(arguments);

    const container = document.createElement('div');

    container.style.color = 'red';
    container.style.position = 'fixed';
    container.style.background = '#eee';
    container.style.padding = '2em';
    container.style.top = '1em';
    container.style.right = '1em';

    let msg = document.createElement('pre');
    msg.innerText = [
        'Message: ' + message,
        'URL: ' + url,
        'Line: ' + lineNo,
        'Column: ' + colNo,
        'Stack: ' + (error && error.stack)
    ].join('\n');

    container.appendChild(msg);

    document.body.appendChild(container);
};
// Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import {Provider} from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from 'app-lib/i18n';
import routes from './routes';
import config from 'config';

// Redux
import configureStore from './Redux/store/configureStore';

// Mixpanel
import * as mixPanel from 'app-lib/mixpanel/mixpanel';

// Action Strings
export const AUTH_START = 'AUTH_START';
export const AUTH_COMPLETE = 'AUTH_COMPLETE';
export const AUTH_FAILURE = 'AUTH_FAILURE';

/**
 * Create Redux Store and App Routes
 */
const store = configureStore();

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

// get the baseurl from the window property
config.app.baseUrl = window.location.origin;
config.assets.url = config.app.version ? `${window.location.origin}/${config.app.version}` : `${window.location.origin}`;

const assetsURL = config.assets && config.assets.url;
/**
 * Render
 */
const renderApp = () => {
    i18n.init({
        backend: {
            loadPath: `${assetsURL}/locales/{{lng}}/{{ns}}.json`
        },
        debug: false, // logs to console if true
        fallbackLng: 'en',
        lngs: ['en', 'it', 'fr', 'zh', 'es', 'de'],
        load: 'languageOnly',
        interpolation: {
            escapeValue: false // not needed for react
        }
    }, () => {
        // Render after gets the default translation
        ReactDOM.render(
            <I18nextProvider i18n={i18n}>
                <Provider store={store}>
                    <Router history={history} routes={routes} />
                </Provider>
            </I18nextProvider>
            , document.querySelector('#root'));
    });
};

mixPanel.fireup();
renderApp();



// WEBPACK FOOTER //
// ./src/main.js